
<p-card class="sameSizeCards container" [ngClass]="{'taskComplete': workOrderWorkTask.workTask.completionStatus == 'Completed' || workOrderWorkTask.workTask.completionStatus =='Unable to be Completed' }">
  <div class="row" [class.highlightDay]="workOrderWorkTask.workTask.completionStatus != 'Completed'
        && workOrderWorkTask.workTask.completionStatus != 'Unable to be Completed'
        &&  isCurrentDate">
    @if (showStatusBar) {
<div class="status-header col-12 row" [ngClass]="{
                                                        'completed': workOrderWorkTask.workTask.completionStatus == 'Completed' || workOrderWorkTask.workTask.completionStatus == 'Unable to be Completed',
                                                        'go-back': workOrderWorkTask.workTask.completionStatus == 'Go Back' || isIncompleteGoBack,
                                                        'rm-follow-up': workOrderWorkTask.workTask.completionStatus == 'Customer Unsatisfied - RM Follow Up'
                                                      }">
        <div class="status-bar col-12">
        <i style="vertical-align: middle;" class="fa" [ngClass]="{
                                              'fa-check': workOrderWorkTask.workTask.completionStatus == 'Completed',
                                              'fa-exclamation': workOrderWorkTask.workTask.completionStatus == 'Customer Unsatisfied - RM Follow Up',
                                              'fa-arrow-left': workOrderWorkTask.workTask.completionStatus == 'Go Back'
                                            }"></i>
          <span style="vertical-align: middle;">&nbsp;{{workOrderWorkTask.workTask.completionStatus == 'Unable to be Completed' ? 'Cancelled' : workOrderWorkTask.workTask.completionStatus}}</span>
          @if (workOrderWorkTask.workTask.paymentStatus) {
            <span style="vertical-align: middle;">&nbsp;|&nbsp;{{workOrderWorkTask.workTask.paymentStatus}}</span>
          }
          @if (workOrderWorkTask.workTask.paidDate) {
            <span style="vertical-align: middle;">&nbsp;|&nbsp;{{workOrderWorkTask.workTask.paidDate | date: 'shortDate'}}</span>
          }
          @if (!workOrderWorkTask.workTask.paymentStatus) {
            <span style="vertical-align: middle;">&nbsp;|&nbsp;Not Paid</span>
          }
          @if (!workOrderWorkTask.workTask.paidDate) {
            <span style="vertical-align: middle;">&nbsp;|&nbsp;No paid date</span>
          }
        </div>
        <br/>
        @if (workOrderWorkTask.workTask.customerIssue && workOrderWorkTask.workTask.completionStatus != 'Completed') {
          <div class="col-12 showLineBreaks">
            {{workOrderWorkTask.workTask.customerIssue}}
          </div>
        }
        @if (workOrderWorkTask.workTask.workTaskGoBackEquipment && workOrderWorkTask.workTask.workTaskGoBackEquipment.length > 0 && workOrderWorkTask.workTask.completionStatus != 'Completed') {
          <div class="col-4">
            Required Equipment Type(s):
          </div>
        }
        @if (workOrderWorkTask.workTask.workTaskGoBackEquipment && workOrderWorkTask.workTask.workTaskGoBackEquipment.length > 0 && workOrderWorkTask.workTask.completionStatus != 'Completed') {
          <div class="col-8">
            @for (wtEquipment of workOrderWorkTask.workTask.workTaskGoBackEquipment; track wtEquipment) {
              <span class="taskStyle">
                {{wtEquipment.equipmentType.type}}
              </span>
            }
          </div>
        }
        @if (isIncompleteGoBack) {
          <div class="col-4">
            <label>Go Back Uploads:</label>
          </div>
        }
        @if (isIncompleteGoBack) {
          <div class="col-8">
            <app-blob-manager [angularUpload]="true"
              [containerName]="'work-task-go-back'"
              [parentRecordId]="uploadId"
              [uploadLabel]="'Document/Photo'"
            [viewOnly]="true"></app-blob-manager>
          </div>
        }
        <div class="col-12">
          @if (canComplete
            && (workOrderWorkTask.workTask.goBackBucketId != undefined)
            && workOrderWorkTask.workTask.completionStatus != 'Completed'
            && workOrderWorkTask.workTask.completionStatus !='Unable to be Completed') {
            <p-button
              type="button"
              label="Complete"
              (click)="showTaskHoursDialog(true)" severity="success" 
              class="ui-button"
            ></p-button>
          }
          @if (canUndo) {
            <p-button type="button" label="Undo Complete" severity="info" icon="fa fa-undo" (click)="undoComplete()"></p-button>
          }
          @if (canComplete
            && workOrderWorkTask.workTask.scheduleDateFrom
            && workOrderWorkTask.workTask.currentBigDaySubrangeId
            && workOrderWorkTask.workTask.completionStatus != 'Completed'
            && workOrderWorkTask.workTask.completionStatus !='Unable to be Completed') {
            <p-button
              
              type="button"
              label="Multiday - Add Hours for Day"
              (click)="showTaskHoursDialogAddHours()"
              class="ui-button editButtonMargin"
            ></p-button>
          }
          @if (canComplete
            && (workOrderWorkTask.workTask.goBackBucketId != undefined)
            && workOrderWorkTask.workTask.completionStatus != 'Completed'
            && workOrderWorkTask.workTask.completionStatus !='Unable to be Completed') {
            <p-button
              
              type="button"
              label="Unable to Complete"
              (click)="showTaskHoursDialogUnableToComplete(true)"
              class="ui-button" severity="danger"
            ></p-button>
          }
        </div>
      </div>
    }
    <div class="col-9" style="text-align: left">
      <h6>{{workOrderWorkTask.workTask?.name}}</h6>
      <h6>
        @if (workOrderWorkTask.workTask.fixedPrice && (canSeeHiddenPrice || !hidePrice)) {
          <span>
            {{workOrderWorkTask.workTask.price | currency}}
          </span>
        }
        @if (!workOrderWorkTask.workTask.fixedPrice && (canSeeHiddenPrice || !hidePrice)) {
          <span>
            @if (workOrderWorkTask.workTask.hourlyRate) {
              <span>{{workOrderWorkTask.workTask.hourlyRate | currency}} per hour</span>
            }
            @if (workOrderWorkTask.workTask.hourlyRate && (workOrderWorkTask.workTask.minPrice || workOrderWorkTask.workTask.maxPrice)) {
              <span> - </span>
            }
            @if (workOrderWorkTask.workTask.minPrice) {
              <span>{{workOrderWorkTask.workTask.minPrice | currency}} minimum</span>
            }
            @if (workOrderWorkTask.workTask.minPrice && workOrderWorkTask.workTask.maxPrice) {
              <span> to </span>
            }
            @if (workOrderWorkTask.workTask.maxPrice) {
              <span>{{workOrderWorkTask.workTask.maxPrice | currency}}</span>
            }
          </span>
        }
        @if ((canSeeHiddenPrice || !hidePrice) && !isCustomer && workOrderWorkTask.workTask.fixedPrice) {
          <span> - </span>
        }
        @if (!isCustomer && workOrderWorkTask.workTask.fixedPrice) {
          <span> {{workOrderWorkTask.workTask.hours | number: '1.0-2'}} hr(s)</span>
        }
      </h6>
    </div>
    @if (fromQuote && workOrderWorkTask.id) {
      <div class="col-3" style="text-align: right">
        <p-checkbox name="agree" [disabled]="true" [(ngModel)]="isSelected" (onChange)="workCheckChanged($event)" binary="true"></p-checkbox>
      </div>
    }
  </div>
  <div class="row">
    <div class="col-9" style="text-align: left">
      <h6 class="showLineBreaks">{{workOrderWorkTask.workTask?.description}}</h6>
    </div>
    <div class="col-3" style="text-align: right">
      @if (isEditable) {
        <p-button
          
          type="button"
          icon="pi pi-copy"
          (click)="copyTask()"
          severity="secondary" class="editMargin">
        </p-button>
      }
      @if (isEditable || canSetGoBack) {
        <p-button
          
          type="button"
          icon="pi pi-pencil"
          (click)="editWorkTask()"
          severity="secondary" class="editMargin">
        </p-button>
      }
      @if (isDeletable()) {
        <p-button
          
          type="button"
          icon="pi pi-trash"
          (click)="deleteWorkTask()"
          severity="danger">
        </p-button>
      }
    </div>
  </div>
  <div class="row">
    @if (!workOrderWorkTask.workTask.isGoBack) {
      <div class="col-12" style="text-align: left">
        @if (canComplete
          && (workOrderWorkTask.workTask.currentBucketId != undefined || workOrderWorkTask.workTask.scheduleDateFrom)
          && workOrderWorkTask.workTask.completionStatus != 'Completed'
          && workOrderWorkTask.workTask.completionStatus !='Unable to be Completed') {
          <p-button
            
            type="button"
            label="Complete"
            (click)="showTaskHoursDialog(false)"
            class="ui-button" severity="success" 
          ></p-button>
        }
        @if (canComplete
          && workOrderWorkTask.workTask.scheduleDateFrom
          && workOrderWorkTask.workTask.currentBigDaySubrangeId
          && workOrderWorkTask.workTask.completionStatus != 'Completed'
          && workOrderWorkTask.workTask.completionStatus !='Unable to be Completed') {
          <p-button
            
            type="button"
            label="Multiday - Add Hours for Day"
            (click)="showTaskHoursDialogAddHours()"
            class="ui-button editButtonMargin"
          ></p-button>
        }
        @if (canComplete
          && (workOrderWorkTask.workTask.currentBucketId != undefined || workOrderWorkTask.workTask.scheduleDateFrom)
          && workOrderWorkTask.workTask.completionStatus != 'Completed'
          && workOrderWorkTask.workTask.completionStatus !='Unable to be Completed') {
          <p-button
            
            type="button"
            label="Unable to Complete"
            (click)="showTaskHoursDialogUnableToComplete(false)"
            class="ui-button" severity="danger"
          ></p-button>
        }
      </div>
    }
  </div>
  @if (workOrderWorkTask.workTask.workTaskTreeTypes && workOrderWorkTask.workTask.workTaskTreeTypes.length > 0) {
    <div class="row" style="text-align: left">
      <div class="col-4">
        Tree Type(s):
      </div>
      <div class="col-8">
        @for (wtTreeType of workOrderWorkTask.workTask.workTaskTreeTypes; track wtTreeType) {
          <span class="taskStyle">
            {{wtTreeType.treeType.commonName}}
          </span>
        }
      </div>
    </div>
  }
  @if (workOrderWorkTask.workTask.location) {
    <div class="row" style="text-align: left">
      <div class="col-4">
        Location of Tree(s):
      </div>
      <div class="col-8">
        {{workOrderWorkTask.workTask.location}}
      </div>
    </div>
  }
  @if (uploadId > 0 && !isCustomer) {
    <div class="row" style="text-align: left">
      <div class="col-4">
        Uploads:
      </div>
      <div class="col-8">
        <app-blob-manager [angularUpload]="true"
          [containerName]="'work-task'"
          [parentRecordId]="uploadId"
          [uploadLabel]="'Document/Photo'"
        [viewOnly]="true"></app-blob-manager>
      </div>
    </div>
  }
  @if (workOrderWorkTask.workTask.workTaskSkills && workOrderWorkTask.workTask.workTaskSkills.length > 0 && !isCustomer) {
    <div class="row" style="text-align: left;">
      <div class="col-4">
        Required Skill(s):
      </div>
      <div class="col-8">
        @for (wtSkill of workOrderWorkTask.workTask.workTaskSkills; track wtSkill) {
          <span class="taskStyle">
            {{wtSkill.skill.name}}
          </span>
        }
      </div>
    </div>
  }
  @if (workOrderWorkTask.workTask.workTaskEquipment && workOrderWorkTask.workTask.workTaskEquipment.length > 0 && !isCustomer) {
    <div class="row" style="text-align: left">
      <div class="col-4">
        Required Equipment Type(s):
      </div>
      <div class="col-8">
        @for (wtEquipment of workOrderWorkTask.workTask.workTaskEquipment; track wtEquipment) {
          <span class="taskStyle">
            {{wtEquipment.equipmentType.type}}
          </span>
        }
      </div>
    </div>
  }

  @if (scheduledBucket && canSeePreviousCrew && !isCustomer) {
    <hr/>
  }
  @if (scheduledBucket && canSeePreviousCrew && !isCustomer) {
    <div class="row" style="text-align: left;">
      <div class="col-4">
        Work Date(s):
      </div>
      <div class="col-8">
        {{scheduledBucket.date | date: 'shortDate'}}@if (goBackScheduledBucket) {
        <span>, {{ goBackScheduledBucket.date | date: 'shortDate' }}</span>
      }
    </div>
    <div class="col-4">
      Crew:
    </div>
    <div class="col-8">
      @for (sbEmployee of scheduledBucket.scheduledBucketEmployees; track sbEmployee) {
        <span class="taskStyle">
          {{sbEmployee.employee.fullName}}
        </span>
      }
      @for (sbEmployee of goBackScheduledBucket?.scheduledBucketEmployees; track sbEmployee) {
        <span class="taskStyle">
          {{sbEmployee.employee.fullName}}
        </span>
      }
    </div>
    <div class="col-4">
      Equipment:
    </div>
    <div class="col-8">
      @for (sbEquipment of scheduledBucket.scheduledBucketEquipment; track sbEquipment) {
        <span class="taskStyle">
          {{sbEquipment.equipment.number}}
        </span>
      }
      @for (sbEquipment of goBackScheduledBucket?.scheduledBucketEquipment; track sbEquipment) {
        <span class="taskStyle">
          {{sbEquipment.equipment.number}}
        </span>
      }
    </div>
  </div>
}

@if (workOrderWorkTask.workTask.taskHourEntries && workOrderWorkTask.workTask.taskHourEntries.length > 0 && canSeePreviousCrew && !isCustomer) {
  <div class="row" style="text-align: left;">
    <div class="col-4">
      Task Hours Total:
    </div>
    <div class="col-8">
      {{taskHourTotal | number: '1.0-2'}}
      @if ( canAdjustHours) {
        <p-button type="button" icon="pi pi-pencil" (click)="showTaskHoursDialog(false, true)"
          severity="secondary" class="editMargin">
        </p-button>
      }
    </div>
  </div>
}
@if (workOrderWorkTask.workTask.isGoBack && workOrderWorkTask.workTask.taskHourEntries && workOrderWorkTask.workTask.taskHourEntries.length > 0 && !isCustomer) {
  <div class="row" style="text-align: left;">
    <div class="col-4">
      Go Back Hours Total:
    </div>
    <div class="col-8">
      {{taskHourGoBackTotal | number: '1.0-2'}}
      <p-button type="button" icon="pi pi-pencil" (click)="showTaskHoursDialog(true, true)"
        severity="secondary" class="editMargin">
      </p-button>
    </div>
  </div>
}
@if (workOrderWorkTask.workTask.jobFeedback && canSeePreviousCrew && !isCustomer) {
  <div class="row" style="text-align: left;">
    <div class="col-4">
      Crew Feedback:
    </div>
    <div class="col-8">
      {{workOrderWorkTask.workTask.jobFeedback}}
    </div>
  </div>
}
@if (workOrderWorkTask.workTask.goBackFeedback && !isCustomer) {
  <div class="row" style="text-align: left;">
    <div class="col-4">
      Go Back Feedback:
    </div>
    <div class="col-8">
      {{workOrderWorkTask.workTask.goBackFeedback}}
    </div>
  </div>
}

@if (workOrderWorkTask.workTask.customerIssue && !isCustomer) {
  <hr/>
}
@if (workOrderWorkTask.workTask.customerIssue && !isCustomer) {
  <div class="row" style="text-align:left">
    <div class="col-4">
      Customer Issue:
    </div>
    <div class="col-8 showLineBreaks">
      {{workOrderWorkTask.workTask.customerIssue}}
    </div>
  </div>
}
@if (workOrderWorkTask.workTask.goBackCompletionDate && !isCustomer) {
  <div class="row" style="text-align: left;">
    <div class="col-4"></div>
    <div class="col-8">
      Resolved {{workOrderWorkTask.workTask.goBackCompletionDate | date: 'shortDate'}}
    </div>
  </div>
}
</p-card>

<p-dialog [(visible)]="showTaskHour" (onHide)="closedTaskHoursDialog()" [modal]="true" [style]="{width: '25em'}" [blockScroll]="true">
  @if (showTaskHour) {
    <app-task-hours-entry
      [asGoBack]="taskHoursForGoBack"
      [complete]="doCompleteTask"
      [customerId]="customerId"
      [quoteNumber]="quoteNumber"
      [task]="workOrderWorkTask.workTask"
      [unableToComplete]="unableToComplete"
      [justUpdate]="justUpdateTaskHours"
      (addHours)="addedHours()"
      (commentId)="addCustomerCommentId($event)"
      (completed)="taskHoursCompleted()"
      (unableToCompleteSubmitted)="taskHoursSubmitted($event)"
      >
    </app-task-hours-entry>
  }
</p-dialog>
